var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bet-dice-market",
      class: { "bet-dice-market--triple": _vm.showTriple },
    },
    [
      _vm.showTriple
        ? _vm._l(_vm.marketGroups, function (group) {
            return _c(
              "div",
              { key: group.label, staticClass: "bet-dice-market__group" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "bet-dice-market__faces bet-dice-market__faces--pair",
                  },
                  _vm._l(group.faces, function (face) {
                    return _c(
                      "button",
                      {
                        key: face,
                        staticClass: "bet-dice-market__face",
                        class: {
                          "bet-dice-market__face--selected":
                            _vm.draftBets[`single-${face}`],
                          "bet-dice-market__face--result-matched":
                            _vm.matchedFaces.includes(face),
                        },
                        attrs: {
                          type: "button",
                          "aria-label": `Single ${face}`,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("bet", `single-${face}`)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.diceImage(face), alt: "" },
                        }),
                        _vm.draftBets[`single-${face}`]
                          ? _c("BetPlacedChip", {
                              attrs: {
                                amount: _vm.draftBets[`single-${face}`],
                                chips: _vm.chips,
                                placement: "top-right",
                                overlap: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "bet-dice-market__label" }, [
                  _vm._v(_vm._s(group.label)),
                ]),
              ]
            )
          })
        : [
            _c("div", { staticClass: "bet-dice-market__compact" }, [
              _c(
                "div",
                {
                  staticClass:
                    "bet-dice-market__faces bet-dice-market__faces--full-row",
                },
                _vm._l(_vm.dieFaces, function (face) {
                  return _c(
                    "button",
                    {
                      key: face,
                      staticClass: "bet-dice-market__face",
                      class: {
                        "bet-dice-market__face--selected":
                          _vm.draftBets[`single-${face}`],
                        "bet-dice-market__face--result-matched":
                          _vm.matchedFaces.includes(face),
                      },
                      attrs: { type: "button", "aria-label": `Single ${face}` },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("bet", `single-${face}`)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.diceImage(face), alt: "" },
                      }),
                      _vm.draftBets[`single-${face}`]
                        ? _c("BetPlacedChip", {
                            attrs: {
                              amount: _vm.draftBets[`single-${face}`],
                              chips: _vm.chips,
                              placement: "top-right",
                              overlap: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              _c("div", { staticClass: "bet-dice-market__labels" }, [
                _c("span", [_vm._v("SINGLE " + _vm._s(_vm.singleOdds))]),
                _c("span", [_vm._v("DOUBLE " + _vm._s(_vm.doubleOdds))]),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }